//
//
//
//
//
//
//

import Overlay from "./Overlay.vue";
import Locations from "./Locations.vue";

export default {
  components: {
    Overlay,
    Locations
  },
  data: function() {
    return {
      overlay: { open: false },
      locations: { open: false }
    };
  },

  mounted() {
    window.PubSub.subscribe("overlay:show", () => {
      this.overlay.open = true;
    });

    window.PubSub.subscribe(
      "locations:show",
      function() {
        this.overlay.open = true;
        this.locations.open = true;
      }.bind(this)
    );

    window.PubSub.subscribe("overlay:click", this.closeElements);
    window.PubSub.subscribe("overlay:hide", this.closeElements);
    window.PubSub.subscribe("locations:hide", this.closeElements);
  },

  methods: {
    closeElements() {
      this.overlay.open = false;
      this.locations.open = false;
    }
  }
};



// WEBPACK FOOTER //
// ./scripts/components/Navigation.vue